import { ParamMap, Params } from '@angular/router';
import { IBase, ITown } from 'src/app/models';
import { ExpeditionType, ServiceType } from 'src/app/models/enums';
import { parseEnumList, parseIdList, serializeIdList, serializeStringList } from './filterUtils';

export interface IServicesPanelFilters {
  selectedClients: IBase[];
  selectedServices: IBase[];
  selectedRoutes: IBase[];
  selectedTypes: ExpeditionType[];
  selectedServiceTypes: ServiceType[];
}

export interface IServicesFilters extends IServicesPanelFilters {
  selectedTowns: ITown[];
}

export const SERVICE_FILTER_KEYS = ['towns', 'clients', 'services', 'routes', 'types', 'serviceTypes'] as const;

export function serializeServicesPanelFilters(filters: IServicesPanelFilters): Params {
  return {
    clients: serializeIdList(filters.selectedClients),
    services: serializeIdList(filters.selectedServices),
    routes: serializeIdList(filters.selectedRoutes),
    types: serializeStringList(filters.selectedTypes),
    serviceTypes: serializeStringList(filters.selectedServiceTypes),
  };
}

export function deserializeServicesFilters(params: ParamMap, fallback?: ITown[]): IServicesFilters {
  return {
    selectedTowns: parseIdList<ITown>(params.get('towns'), fallback),
    selectedClients: parseIdList(params.get('clients')),
    selectedServices: parseIdList(params.get('services')),
    selectedRoutes: parseIdList(params.get('routes')),
    selectedTypes: parseEnumList<ExpeditionType>(params.get('types')),
    selectedServiceTypes: parseEnumList<ServiceType>(params.get('serviceTypes')),
  };
}

export function hasServicesPanelFilters(filters: IServicesPanelFilters): boolean {
  return [
    filters.selectedClients,
    filters.selectedServices,
    filters.selectedRoutes,
    filters.selectedTypes,
    filters.selectedServiceTypes,
  ].some((selection) => selection.length > 0);
}

export function parseServicesPanelFilterParamsFromStorage(json: string | null | undefined): Params {
  if (!json) return {};
  try {
    const stored = JSON.parse(json);
    return stored && typeof stored === 'object' && !Array.isArray(stored) ? stored : {};
  } catch {
    return {};
  }
}

export function parseServicesTownsFromStorage(json: string | null | undefined): ITown[] {
  if (!json) return [];
  try {
    const v = JSON.parse(json);
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}
